import { render, staticRenderFns } from "./WorkerFormInterview.vue?vue&type=template&id=2bc7bde9&scoped=true"
import script from "./WorkerFormInterview.vue?vue&type=script&lang=ts"
export * from "./WorkerFormInterview.vue?vue&type=script&lang=ts"
import style0 from "./WorkerFormInterview.vue?vue&type=style&index=0&id=2bc7bde9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7bde9",
  null
  
)

export default component.exports